<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/coach')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="pt_name">Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="pt_name" v-model="pt_name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="email">Email</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="email" v-model="email" name="email" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('email') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_pt">Image</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file name="file" v-validate="'required'" @change="previewImage" accept="image/*" v-model="file" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                  <div class="image-preview" v-if="imageData.length > 0">
                      <img class="preview" :src="imageData">
                  </div>
                  <span class="error">{{ errors.first('file') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="short_description">Specialist</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="short_description" name="specialist" v-validate="'required'" v-model="short_description" type="text"></b-form-input>
                  <span class="error">{{ errors.first('specialist') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="description">Description</label>
                </b-col>
                <b-col sm="10">
                  <textarea id="description" name="description" class="w-100" rows="3" v-model="description"></textarea>
                </b-col>
              </b-row>
              <hr>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="branch_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Status Group</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="is_group" v-validate="'required'" v-model="is_group" :options="optionsGroup" />
                  <span class="error">{{ errors.first('is_group') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20" v-if="is_group === 1">
                <b-col sm="2">
                  <label>Instructor Group</label>
                </b-col>
                <b-col sm="10">
                  <div class="custom-search-select">
                    <multi-select :options="optionsAllGroup" :selected-options="optGroupInstructor"  @select="onSelect" placeholder="Please Select" class="border-bottom" name="optGroupInstructor"></multi-select>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Own Rate (Rp)</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="own_rate" name="own_rate" v-validate="'numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('own_rate') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Ninety Mins Rate (Rp)</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="ninety_mins_rate" name="ninety_mins_rate" v-validate="'numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('ninety_mins_rate') }}</span>
                </b-col>
              </b-row>
              <hr>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_pt">Status</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="status" v-validate="'required'" v-model="selected" :options="options" class="mb-3" />
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Show on Mobile</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_show_on_mobile" name="is_show_on_mobile" :sync="true"/>
                  <span class="error">{{ errors.first('is_show_on_mobile') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="barcode">Barcode</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="barcode" name="barcode" v-model="barcode" type="number"></b-form-input>
                </b-col>
              </b-row>
              <div class="font-bold">MOBILE</div>
              <hr class="mt-5">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Instagram</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="instagram" name="instagram" type="text"></b-form-input>
                  <span style="font-size: 12px;color: grey;font-style: italic;">*instagram username example <b>@jehanislianur</b></span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Purpose</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="purpose" ref="myTextEditor" v-model="purpose_text" :options="editorOption"></quill-editor>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Certification</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="certification" ref="myTextEditor" v-model="certification_text" :options="editorOption"></quill-editor>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Classes</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="speciality" ref="myTextEditor" v-model="speciality_text" :options="editorOption"></quill-editor>
                  </div>
                </b-col>
              </b-row>
              <hr>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import { MultiSelect } from 'vue-search-select'

export default {
  name: 'addCoach',
  components: {
    MultiSelect
  },
  data: function () {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote'],
            [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }], 
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ]
        }
      },
      dataBranch: [],
      pt_name: '',
      branch_id: null,
      barcode: 0,
      imageData: '',
      file: null,
      short_description: '',
      description: '',
      selected: null,
      own_rate: '',
      ninety_mins_rate: '',
      email: '',
      is_group: null,
      optGroupInstructor: [],
      coaches_group_id: [],
      lastSelectItem: {},
      is_show_on_mobile: false,
      instagram: '@yourinstagramusername',
      speciality_text: '',
      certification_text: '',
      purpose_text: '',
      optionsGroup: [
        { value: null, text: 'Please select' },
        { value: 1, text: 'Yes' },
        { value: 0, text: 'No' }
      ],
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ],
      optionsAllGroup: []
    }
  },
  methods: {
    onSelect (items, lastSelectItem) {
      this.optGroupInstructor = items
      this.coaches_group_id.push(lastSelectItem.value)
    },
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          data.append('photos', this.file)
          data.append('name', this.pt_name)
          data.append('status', this.selected)
          data.append('short_description', this.short_description)
          data.append('description', this.description)
          data.append('email', this.email)
          data.append('own_rate', this.own_rate)
          data.append('ninety_mins_rate', this.ninety_mins_rate)
          data.append('branch_id', this.branch_id)
          data.append('is_group', this.is_group)
          data.append('barcode', this.barcode)

          data.append('is_show_on_mobile', this.is_show_on_mobile ? 1 : 0)
          data.append('instagram', this.instagram)
          data.append('speciality_text', this.speciality_text)
          data.append('certification_text', this.certification_text)
          data.append('purpose_text', this.purpose_text)
          
          if(this.is_group === 1) {
            data.append('coaches_group_id', this.coaches_group_id.join())
          } else {
            data.append('coaches_group_id', '')
          }
          axios.post('fitness/v1/coaches/', data).then(response => {
            // console.log('test', response)
            this.$router.push('/coach')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('fitness/v1/coaches').then(response => {
        var dataInstructor = response.data.data.rows
        for (var i = 0; i < dataInstructor.length; i++) {
          var dataComplete = Object.assign({}, {value: dataInstructor[i].user_id, text: dataInstructor[i].name})
          this.optionsAllGroup.push(dataComplete)
        }
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
